export default __webpack_public_path__ + "static/media/logo.fa46449f.svg";